import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import PageWrap from '@components/PageWrap'
import Navigation from '@components/Navigation'
import MailingList from '@components/MailingList'
import { ReactComponent as Twitter } from '@assets/svgs/icons/twitter.svg'
import { ReactComponent as LinkedIn } from '@assets/svgs/icons/linkedin.svg'
import { ReactComponent as Facebook } from '@assets/svgs/icons/facebook.svg'
import { ReactComponent as Instagram } from '@assets/svgs/icons/instagram.svg'
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import { ReactComponent as Youtube } from '@assets/svgs/icons/youtube.svg'

import './Footer.module.scss'

const Rospa = require('@assets/pngs/rospa_logo.png')

const Footer = ({
  data: { legalText,
    legalMenu,
    smallNavigationTitle,
    smallNavigationMenu,
    largeNavigationTitle,
    largeNavigationMenu,
    twitter,
    linkedin,
    facebook,
    youtube,
    instagram,
    mailingListTitle,
    mailingListThankYouMessage
  }
}) => (
  <footer>
    <section styleName='primary'>
      <PageWrap>
        <div styleName='content'>
          <div styleName='menus'>
            <div styleName='small-menu'>
              <h2 styleName='title'>{smallNavigationTitle}</h2>
              {R.not(R.isEmpty(smallNavigationMenu)) && <Navigation links={smallNavigationMenu} />}
            </div>
            <div styleName='large-menu'>
              <h2 styleName='title'>{largeNavigationTitle}</h2>
              {R.not(R.isEmpty(largeNavigationMenu)) && <Navigation links={largeNavigationMenu} />}
            </div>
          </div>
          <div styleName='contact'>
            <div>
              <MailingList title={mailingListTitle} message={mailingListThankYouMessage} />
            </div>
            <div styleName='social'>
              {twitter && (
                <a href={twitter} target='_blank'>
                  <Twitter styleName='twitter' aria-hidden='true' />
                  <span className='sr-only'>Twitter</span>
                </a>
              )}
              {linkedin && (
                <a href={linkedin} target='_blank'>
                  <LinkedIn styleName='linkedin' aria-hidden='true' />
                  <span className='sr-only'>LinkedIn</span>
                </a>
              )}
              {facebook && (
                <a href={facebook} target='_blank'>
                  <Facebook styleName='facebook' aria-hidden='true' />
                  <span className='sr-only'>Facebook</span>
                </a>
              )}
              {instagram && (
                <a href={instagram} target='_blank'>
                  <Instagram styleName='instagram' aria-hidden='true' />
                  <span className='sr-only'>Instagram</span>
                </a>
              )}
              {youtube && (
                <a href={youtube} target='_blank'>
                  <Youtube styleName='youtube' aria-hidden='true' />
                  <span className='sr-only'>YouTube</span>
                </a>
              )}
            </div>
            <img alt='ROSPA Member logo' data-src={Rospa} width='124' height='63' className='lazyload' styleName='rospaLogo' />
          </div>
        </div>
      </PageWrap>
    </section>
    <section styleName='secondary'>
      <PageWrap>
        <div styleName='inner-wrap'>
          <span styleName='copyright'>&copy; {legalText}</span>
          {R.not(R.isEmpty(legalMenu)) && <Navigation links={legalMenu} />}
        </div>
      </PageWrap>
    </section>
  </footer>
)

Footer.propTypes = {
  data: PropTypes.object
}

Footer.defaultProps = {
  data: {
    largeNavigationTitle: '',
    largeNavigationMenu: [],
    smallNavigationTitle: '',
    smallNavigationMenu: [],
    mailingListTitle: '',
    mailingListThankYouMessage: '',
    twitter: '',
    linkedin: '',
    facebook: '',
    legalMenu: [],
    legalText: ''
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js